// src/publish/pieces/linkedinPost.js — pieces of the LinkedIn post (format key 'linkedin-post').
//
// The backend sends hook / body / cta / hashtags (title is empty and, when it
// is not, it is NOT part of the post: the post has no title box). Pieces:
//   post      primary, kind 'plain', limit LIMITS.linkedinPost —
//             hook + body + cta + the hashtag line, exactly what full_text is
//   hashtags  kind 'tags', only when the backend sent any
// No link piece: the LinkedIn post carries no cta_url field (see the proposal's
// AS IS table) and the URL, when there is one, is already in the text.
// Also exports socialPostBlocks(content), the «Post completo» composition the
// Facebook and Instagram builders share (same backend fields, same order).
// Labels / destinations: outputs:pieces.labels.linkedin-post.* and
// outputs:pieces.destinations.linkedin-post.* (see ../piece.js header).

import { normalizeText } from '../normalize.js';
import { makePiece, tagsBlocks, ensureOnePrimary, str, LIMITS } from '../piece.js';

const FORMAT = 'linkedin-post';

/**
 * The full social post as blocks: hook, body, cta (each a backend text field
 * that may carry Markdown bold and line breaks) and, last, the "#a #b" line.
 */
export function socialPostBlocks(content) {
  if (!content || typeof content !== 'object') return [];
  return [
    ...normalizeText(str(content.hook)),
    ...normalizeText(str(content.body)),
    ...normalizeText(str(content.cta)),
    ...tagsBlocks(content.hashtags),
  ];
}

export function build(entry) {
  const content = entry?.results?.content;
  if (!content || typeof content !== 'object') return [];
  const pieces = [];

  const post = socialPostBlocks(content);
  if (post.length) pieces.push(makePiece(FORMAT, { id: 'post', primary: true, blocks: post, limit: LIMITS.linkedinPost }));

  const tags = tagsBlocks(content.hashtags);
  if (tags.length) pieces.push(makePiece(FORMAT, { id: 'hashtags', kind: 'tags', blocks: tags }));

  return ensureOnePrimary(pieces);
}
